// Project Setting
export default {
    // document
    suffix: " - 剑网3魔盒（JX3BOX）",
    title: "剑三魔盒",
    keywords: "jx3box,剑三工具箱,插件,资源,开源,剑三box,剑三魔盒,剑三宏,剑三插件,剑三辅助,副本攻略,副本解包,团队监控,捏脸数据,剑3数据库,成就百科,剑三成就,剑3,剑网3",
    description: "剑网3工具箱，提供各种实用的工具和插件，助你轻松游戏，畅享剑网3！",
};
